import { MessagesSquare } from "lucide-react";

const CommunicationTileDesign = {
  id: "communication",
  icon: MessagesSquare,
  label: "Communication",
  background: "linear-gradient(135deg, var(--color-primary-dark), var(--color-primary))",
  color: "#ffffff",
};

export default CommunicationTileDesign;
